var _rect, _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolatility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5491 30.709H23.0491V30.209V18.373H31.3197V30.2009V30.7009H31.8197H36.7913L27.1802 40.2937L17.5701 30.709H22.5491ZM10.6803 14.791V14.291H10.1803H5.20937L14.8195 4.7063L24.4225 14.291H19.4509H18.9509V14.791V26.6189H10.6803V14.791Z",
    fill: "url(#paint0_linear_24786_52051)",
    stroke: "url(#paint1_radial_24786_52051)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_24786_52051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 22C36.6377 22 33.3509 22.997 30.5553 24.865C27.7597 26.733 25.5807 29.388 24.2941 32.4944C23.0074 35.6007 22.6707 39.0189 23.3267 42.3165C23.9826 45.6142 25.6017 48.6433 27.9792 51.0208C30.3567 53.3983 33.3858 55.0174 36.6835 55.6733C39.9811 56.3293 43.3993 55.9926 46.5056 54.7059C49.612 53.4193 52.267 51.2403 54.135 48.4447C56.003 45.6491 57 42.3623 57 39C56.9947 34.4929 55.2019 30.172 52.0149 26.9851C48.828 23.7981 44.5071 22.0053 40 22Z",
    fill: "url(#paint2_linear_24786_52051)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 22C36.6377 22 33.3509 22.997 30.5553 24.865C27.7597 26.733 25.5807 29.388 24.2941 32.4944C23.0074 35.6007 22.6707 39.0189 23.3267 42.3165C23.9826 45.6142 25.6017 48.6433 27.9792 51.0208C30.3567 53.3983 33.3858 55.0174 36.6835 55.6733C39.9811 56.3293 43.3993 55.9926 46.5056 54.7059C49.612 53.4193 52.267 51.2403 54.135 48.4447C56.003 45.6491 57 42.3623 57 39C56.9947 34.4929 55.2019 30.172 52.0149 26.9851C48.828 23.7981 44.5071 22.0053 40 22Z",
    fill: "url(#paint3_radial_24786_52051)",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_24786_52051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2745 45.5472C44.9846 45.8369 44.5916 45.9997 44.1818 45.9997C43.772 45.9997 43.379 45.8369 43.0892 45.5472L38.4528 40.9108C38.163 40.6211 38.0001 40.228 38 39.8182V30.5455C38 30.1356 38.1628 29.7425 38.4527 29.4527C38.7425 29.1628 39.1356 29 39.5455 29C39.9553 29 40.3484 29.1628 40.6383 29.4527C40.9281 29.7425 41.0909 30.1356 41.0909 30.5455V38.7641C41.0909 39.0294 41.1963 39.2837 41.3838 39.4713L45.2745 43.3619C45.5642 43.6517 45.7269 44.0447 45.7269 44.4545C45.7269 44.8643 45.5642 45.2574 45.2745 45.5472Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_24786_52051",
    x: 15,
    y: 14,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24786_52051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24786_52051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_24786_52051",
    x: 38,
    y: 29,
    width: 8.72656,
    height: 17.9996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24786_52051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24786_52051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24786_52051",
    x1: 4,
    y1: 4,
    x2: 23.4168,
    y2: 39.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_24786_52051",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-5.15384 -13.7885) rotate(57.7632) scale(42.9017 41.4901)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24786_52051",
    x1: 23,
    y1: 22,
    x2: 40,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_24786_52051",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23 22) scale(34)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolatility);
export default __webpack_public_path__ + "static/media/volatility.c3436bb1df90a20517497fcddad5be65.svg";
export { ForwardRef as ReactComponent };